import type { Dispatch, SetStateAction } from 'react';
import type { TableState } from '../types';
import { usePersistentState, type RestoreState } from './usePersistentState';

type UsePersistentTableStateOptions = {
  restore?: RestoreState<TableState>;
};

const defaultRestoreTableState: RestoreState<TableState> = (
  storedState,
  initialState,
) => {
  return {
    sorting: storedState.sorting ?? initialState.sorting,
    columnFilters: storedState.columnFilters ?? initialState.columnFilters,
    columnVisibility:
      storedState.columnVisibility ?? initialState.columnVisibility,
  };
};

export function usePersistentTableState(
  tableId: string,
  initialState: TableState,
  options: UsePersistentTableStateOptions = {},
): [TableState, Dispatch<SetStateAction<TableState>>] {
  return usePersistentState(
    tableId,
    initialState,
    options.restore ?? defaultRestoreTableState,
  );
}
